module.exports = __webpack_public_path__ + "img/zx-act.b8a0310c.png";